import { AVAILABLE, AWAY, BUSY, INACTIVE } from '../constants/agent-state';
import { CAPACITY_CONFIG_TYPES } from '../../agent-status/constants';
import { isHumanAgent } from '../operators/assignees';
import { isAgentOnCall } from '../../agent-status/utils/capacityUtils';
export const getAgentCapacityMessageType = (agent, canUseCalling, capacityCategory) => {
  var _agent$userCapacityDa, _agent$userCapacityDa2;
  if (!isHumanAgent(agent)) {
    return null;
  }
  if (canUseCalling && isAgentOnCall(agent)) {
    return 'ON_A_CALL';
  }
  const capacityConfigType = (_agent$userCapacityDa = (_agent$userCapacityDa2 = agent.userCapacityDataResult) === null || _agent$userCapacityDa2 === void 0 ? void 0 : _agent$userCapacityDa2.capacityConfigurationType) !== null && _agent$userCapacityDa !== void 0 ? _agent$userCapacityDa : CAPACITY_CONFIG_TYPES.TOTAL;
  switch (agent.capacityStatus) {
    case 'FULL':
      if (capacityConfigType === CAPACITY_CONFIG_TYPES.TOTAL) {
        return 'FULL_TOTAL';
      }
      return capacityCategory === 'REAL_TIME_MESSAGING' ? 'FULL_MESSAGING' : 'FULL_ASYNC';
    case 'OVER':
      if (capacityConfigType === CAPACITY_CONFIG_TYPES.TOTAL) {
        return 'OVER_TOTAL';
      }
      return capacityCategory === 'REAL_TIME_MESSAGING' ? 'OVER_MESSAGING' : 'OVER_ASYNC';
    default:
      return null;
  }
};
export const getAgentAvailabilityMessageType = (agentState, agent) => {
  if (!isHumanAgent(agent)) {
    return null;
  }
  if (agent.isOutOfOffice) {
    return 'OUT_OF_OFFICE';
  }
  if (agentState === AWAY) {
    return agent.isInWorkingHours ? 'AWAY' : 'AWAY_OUTSIDE_WH';
  }
  switch (agentState) {
    case AVAILABLE:
    case BUSY:
      return 'AVAILABLE';
    case INACTIVE:
      return 'INACTIVE';
    default:
      return null;
  }
};
export const getAgentMessageTypes = (responder, showCapacityStatus, canUseCalling, capacityCategory) => {
  const availability = getAgentAvailabilityMessageType(responder.agentState, responder.agent);
  let capacity = null;
  if (showCapacityStatus) {
    capacity = getAgentCapacityMessageType(responder.agent, canUseCalling, capacityCategory);
  }
  return {
    availability,
    capacity
  };
};